module.exports = __webpack_public_path__ + "static/media/logo2.688a6931.png";